import {css} from 'lit';
export const styles = css`:host {
  --background-color: var(--contrast-light);
  --color: var(--contrast-dark);
  --icon-font-size-primary: 1.25em;
  --font-size-primary: var(--font-size-base);
  --min-width: 20px;
  --el-border-radius: 0;

  display: block;
}

  @media (min-width: 786px) {:host {
    overflow: hidden
}
  }

a {
  --link-text: var(--color);

  display: block;
  padding: 16px;
  background-color: var(--background-color);
  font-weight: 700;
  border-radius: var(--el-border-radius);
}

:host a.focus-visible {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: -4px;
}

:host a:focus-visible {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: -4px;
}

@media (hover: hover) {
  :host(:hover) {
    --link-text-hover: var(--color);
    --background-color: var(--gray-200);
  }
}

:host(:active) a {
  --link-text-active: var(--color);
  --background-color: var(--gray-300);
}

:host([active]),
:host([active]:active) a {
  --background-color: var(--primary-200);
}
`;
export default styles;
